import CoursesBlockPreview from "./CoursesBlockPreview";

export default CoursesBlockPreview;